import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  marginBottom: {
    marginBottom: theme.spacing(3),
  },
  order: {
    minHeight: theme.spacing(150),
    height: "100% !important",
    width: "100%",
  },
  chart: {
    height: theme.spacing(150),
    width: "100%",
  },
  OrderBook: {
    height: theme.spacing(170),
    width: "100% !important",
  },
  RecentTransactionsLayout: {
    height: theme.spacing(170),
    width: "100%",
  },
  table: {
    height: theme.spacing(170),
    width: "100%",
  },
}));
